<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    :max-width="'max-w-[400px]'"
    @close="$emit('close')"
  >
    <div class="mx-1">
      <span
        class="-mt-5 mb-4 flex w-max cursor-pointer text-left text-neutral-subtle"
        @click="handleResetSort"
      >
        Reset
      </span>
      <h4 class="text-left text-2xl text-dark-blue">Sort by</h4>

      <div v-if="isLoadsDashboard">
        <round-radio-button
          name="sort"
          value="best"
          :show="true"
          :checked="selectedSort === 'best'"
          :handle-click="($event) => handleSelectSort($event, 'best')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'best' }"
          >
            Best Match
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="rpm"
          :show="true"
          :checked="selectedSort === 'rpm'"
          :handle-click="($event) => handleSelectSort($event, 'rpm')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            RPM (Highest)
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="pickup"
          :show="true"
          :checked="selectedSort === 'pickup'"
          :handle-click="($event) => handleSelectSort($event, 'pickup')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'pickup' }"
          >
            Pickup Date (Earliest)
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="posting_desc"
          :show="true"
          :checked="selectedSort === 'posting_desc'"
          :handle-click="($event) => handleSelectSort($event, 'posting_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'posting_desc' }"
          >
            Load Age (Newest)
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="price_desc"
          :show="true"
          :checked="selectedSort === 'price_desc'"
          :handle-click="($event) => handleSelectSort($event, 'price_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'price_desc' }"
          >
            Rate (Highest)
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="distance_asc"
          :show="true"
          :checked="selectedSort === 'distance_asc'"
          :handle-click="($event) => handleSelectSort($event, 'distance_asc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'distance_asc' }"
          >
            Trip Distance (Shortest)
          </p>
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="distance_desc"
          :show="true"
          :checked="selectedSort === 'distance_desc'"
          :handle-click="($event) => handleSelectSort($event, 'distance_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'distance_desc' }"
          >
            Trip Distance (Longest)
          </p>
        </round-radio-button>
      </div>

      <div v-else>
        <round-radio-button
          item="Origin"
          name="sort"
          value="origin"
          :show="true"
          :checked="selectedSort === 'origin'"
          :handle-click="($event) => handleSelectSort($event, 'origin')"
        />
        <round-radio-button
          item="Destination"
          name="sort"
          value="destination"
          :show="true"
          :checked="selectedSort === 'destination'"
          :handle-click="($event) => handleSelectSort($event, 'destination')"
        />
      </div>

      <button-main
        class="mb-2 mt-4 text-1md"
        :disabled="!selectedSort"
        @click="handleApplySort"
      >
        Apply
      </button-main>
    </div>
  </bottom-sheet>
</template>

<script>
import { ref, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BottomSheet from '@/components/BottomSheet.vue';
import RoundRadioButton from '@/components/RoundRadioButtonLoads.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'LoadSortBottomSheet',
  components: {
    BottomSheet,
    RoundRadioButton,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    isLoadsDashboard: Boolean,
  },
  emits: ['close'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();

    const selectedSort = ref('best');

    onBeforeMount(() => {
      const querySort = router.currentRoute.value.query?.sort;

      if (querySort) {
        selectedSort.value = querySort;
      }
    });

    const handleSelectSort = (item, value) => {
      selectedSort.value = value;
    };

    const handleResetSort = () => {
      selectedSort.value = 'best';
      const existingSort = router.currentRoute.value.query?.sort;
      const existingQueries = router.currentRoute.value.query;

      // eslint-disable-next-line no-unused-vars
      const { sort, ...rest } = existingQueries || {};

      if (existingSort) {
        router.push({
          query: {
            ...rest,
          },
        });
      }

      emit('close');
    };

    const handleApplySort = () => {
      // getLoads request either here or in watch func in /MyLoads
      const existingSort = router.currentRoute.value.query?.sort;
      const existingQueries = router.currentRoute.value.query;
      console.log('existing', existingSort, '/', selectedSort.value);

      if (existingSort !== selectedSort.value) {
        store.commit('loads/setLoading', true);

        const query = {
          ...existingQueries,
          sort: selectedSort.value,
        };
        if (selectedSort.value === 'best') {
          delete query.sort;
        }

        router.push({
          query,
        });
      }

      emit('close');
    };
    return {
      selectedSort,
      handleResetSort,
      handleApplySort,
      handleSelectSort,
    };
  },
};
</script>
